import { render, staticRenderFns } from "./DraggableListItem.vue?vue&type=template&id=5147d9ce&scoped=true&"
import script from "./DraggableListItem.vue?vue&type=script&lang=js&"
export * from "./DraggableListItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListItem.vue?vue&type=style&index=0&id=5147d9ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147d9ce",
  null
  
)

export default component.exports